module.exports = __webpack_public_path__ + "static/media/b-1.2f6f3a69.jpg";